import { SYMBOLS } from '../context/CurrencyContext';

export const isLocal = (o) => !!(o?.currency && o.currency !== 'USD' && o.fx_rate);

export const unitLocal = (o, usd) => (isLocal(o) ? Math.round(Number(usd) * Number(o.fx_rate)) : Number(usd));

export const money = (o, amount) => `${isLocal(o) ? SYMBOLS[o.currency] || '' : '$'}${Number(amount || 0).toFixed(2)}`;

export const orderTotals = (o, src = o) => {
  const L = isLocal(o) && src.local_totals ? src.local_totals : null;
  const discount = src.discountAmount ?? src.discount ?? 0;
  return {
    subtotal: L ? L.subtotal : src.subtotal,
    shipping: L ? L.shipping : src.shipping,
    discount: L ? L.discount : discount,
    total: L ? L.total : src.total,
  };
};

export const fmtDate = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleString(undefined, { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
};
